exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html, body {\n  font-family: 'Gudea', sans-serif;\n  font-size: 7vh;\n  margin: 0px;\n  overflow: hidden;\n  height: 100vh;\n  color: white;\n  background-color: #37474f; }\n\n.Loader {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  font-size: 2em; }\n\n* {\n  box-sizing: border-box; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/App.scss
// module id = 327
// module chunks = 0